export default __webpack_public_path__ + "static/media/w_m_2021_a.d2458ace.jpeg";